import { TOUR_ANCHORS } from 'scenes/RecoveryAI/Sandbox/tourAnchors'
import type { TourStep } from './types'

// The ordered 3-step SECOND tour, shown once the merchant reaches the "Test your
// own" free phase. It celebrates the guided run, points at the chat for BYO
// testing, then at the wizard's Continue button. title/body keys resolve under
// `recovery_ai.wizard.tour2.steps.*`; the last step finishes with "Got it".
export const TOUR2_STEPS: TourStep[] = [
  {
    id: 'simulator',
    anchorId: TOUR_ANCHORS.simulator,
    titleKey: 'steps.seen.title',
    bodyKey: 'steps.seen.body',
    // ENG-974: the "Nice work" notice is about the whole run, not one control —
    // render it as a centered modal over a full-screen dim.
    centered: true,
  },
  {
    id: 'chatInput',
    anchorId: TOUR_ANCHORS.chatInput,
    titleKey: 'steps.test_own.title',
    bodyKey: 'steps.test_own.body',
    // ENG-975: the chat input sits at the BOTTOM of the phone, so a top/bottom
    // placement lands the card over the device. Put it beside the phone instead.
    placement: 'right',
    // AI-1116: the one step where the highlighted control stays interactive —
    // the merchant types into the real chat input mid-tour.
    interactive: true,
  },
  {
    id: 'continueButton',
    anchorId: TOUR_ANCHORS.continueButton,
    titleKey: 'steps.ready.title',
    bodyKey: 'steps.ready.body',
    ctaKey: 'pager.got_it',
  },
]

export const TOUR2_STEP_IDS: string[] = TOUR2_STEPS.map(step => step.id)
